import axios from '@/server/axios'
//园区荣耀图片
export function queryAllPic(email) {
  return axios({
    url: 'officialWebsite/queryAllPic',
    method: 'get'
  })
}